import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { DropdownModule } from 'primeng/dropdown'
import { LeaderboardComponent } from './leaderboard.component'
import { NgApexchartsModule } from 'ng-apexcharts'
import { SharedModule } from '../shared/shared.module'
import { LeaderboardRankTableComponent } from './leaderboard-rank-table/leaderboard-rank-table.component'

@NgModule({
   declarations: [LeaderboardComponent, LeaderboardRankTableComponent],
   imports: [CommonModule, FormsModule, DropdownModule, SharedModule, NgApexchartsModule],
})
export class LeaderboardModule {}
